module.exports = __webpack_public_path__ + "img/img04.2228dedb.png";